import { createKeyedStore } from '@/common/utils/keyedStore';
import type { TreeSetDiff } from './treeSetDiff';

/** A self-edit's auto-promoted diff that repositioned at least one row. */
export type MovedNotice = {
  diff: TreeSetDiff;
};

// clearOnUnsubscribe stays false so a remount can't discard an unconsumed notice. Unbounded
// search-term keys are swept instead by itemsTreeSetConsistency.ts's startQueryRemovalCleanup.
const store = createKeyedStore<MovedNotice>({ clearOnUnsubscribe: false });

export const getMovedNotice = (queryKeyString: string): MovedNotice | undefined =>
  store.get(queryKeyString);

export const subscribeMovedNotice = (queryKeyString: string, listener: () => void): (() => void) =>
  store.subscribe(queryKeyString, listener);

/** Overwrites rather than queues — a later reconciliation supersedes whatever was published before. */
export const publishMovedNotice = (queryKeyString: string, diff: TreeSetDiff): void =>
  store.set(queryKeyString, { diff });

export const clearMovedNotice = (queryKeyString: string): void => store.delete(queryKeyString);
